import { render, staticRenderFns } from "./UpdateMainboard.vue?vue&type=template&id=2fe1f49e&"
import script from "./UpdateMainboard.vue?vue&type=script&lang=js&"
export * from "./UpdateMainboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports